<div class="loader">
    <!--Create a number of div for each dots.-->
    @for (loader of counters; track loader; let i = $index) {
        <div></div>
    }
</div>
